var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { applyOgImageModifications } from '../utils/build-og-image';
import { resolvePayload } from './resolve-payload';
import { resolveIsIndexable } from './utils/resolve-is-indexable';
import { sort } from './sort';
import { getLink } from './utils/get-link';
import { cleanBlackListedTags } from './utils/clean-black-listed-tags';
import { fillInPatternBlob } from '../patterns/fill-in-pattern-blob';
import adapter from '../item-types/static-page/adapter-static-page';
import { removeBlackListedTags } from './utils/remove-black-listed-tags';
import { applyOptions } from '../options/apply-options';
export function resolveWithPatterns(payload, context, shouldRemoveBlackListTags) {
    if (shouldRemoveBlackListTags === void 0) { shouldRemoveBlackListTags = false; }
    var result = resolvePayload(payload);
    var contextWithOptions = __assign(__assign({}, context), applyOptions(result.options));
    result.tags = resolveIsIndexable(result.tags, contextWithOptions);
    result.tags = result.tags
        .concat(getLink(contextWithOptions, adapter.IDs.NEXT, 'next'))
        .concat(getLink(contextWithOptions, adapter.IDs.PREV, 'prev'));
    result = fillInPatternBlob(result, contextWithOptions);
    result.tags = applyOgImageModifications(result.tags);
    if (shouldRemoveBlackListTags) {
        result.tags = removeBlackListedTags(result.tags);
    }
    else {
        result.tags = cleanBlackListedTags(result.tags);
    }
    result.tags = sort(result.tags);
    return result;
}
